import { PaginatedApiResponse } from '@shared/models/paginated-api-response';
import { IArticle } from '@shared/shared/interfaces/article.interfaces';
import { Inspiration, InspirationState } from '../../models/inspiration.interface';
import * as inspirationActions from './inspiration.actions';
import { InspirationAction } from './inspiration.actions';

export const initialState: InspirationState = {
  allInspirations: {} as PaginatedApiResponse<Inspiration>,
  viewedInspiration: null,
  featuredFormatInspirations: [],
  featuredInspirations: {} as PaginatedApiResponse<Inspiration>,
  inspirationFormats: [],
  article: {} as IArticle,
  publication: {},
};

export function reducer(state = initialState, action: InspirationAction): InspirationState {
  switch (action.type) {
    case inspirationActions.GET_ALL_INSPIRATIONS: {
      return {
        ...state,
        allInspirations: {
          ...state.allInspirations,
          loading: true,
          results: [],
        },
      };
    }

    case inspirationActions.LOAD_MORE_INSPIRATIONS: {
      return {
        ...state,
        allInspirations: {
          ...state.allInspirations,
          loading: true,
        },
      };
    }

    case inspirationActions.GET_ALL_INSPIRATIONS_SUCCESS: {
      const stateResults = state.allInspirations?.results ? state.allInspirations.results : [];

      return {
        ...state,
        allInspirations: {
          ...action.payload,
          loading: false,
          results: [...stateResults, ...action.payload.results],
        },
      };
    }

    case inspirationActions.GET_ALL_INSPIRATIONS_FAILURE: {
      const stateResults = state.allInspirations?.results ? state.allInspirations.results : [];

      return {
        ...state,
        allInspirations: {
          ...action.payload,
          loading: false,
          results: [...stateResults, ...action.payload.results],
        },
      };
    }

    case inspirationActions.RESET_ALL_INSPIRATIONS: {
      return {
        ...state,
        allInspirations: { ...initialState.allInspirations },
      };
    }

    case inspirationActions.GET_FEATURED_FORMAT_INSPIRATIONS: {
      const formatInspirations = { ...state.featuredFormatInspirations };
      formatInspirations[action.payload.format] = { ...formatInspirations[action.payload.format], loading: true };

      return {
        ...state,
        featuredFormatInspirations: { ...state.featuredFormatInspirations, ...formatInspirations },
      };
    }

    case inspirationActions.GET_FEATURED_FORMAT_INSPIRATIONS_SUCCESS: {
      const formatInspirations = { ...state.featuredFormatInspirations };
      formatInspirations[action.formatId] = { ...action.inspirations, loading: false };

      return {
        ...state,
        featuredFormatInspirations: { ...state.featuredFormatInspirations, ...formatInspirations },
      };
    }

    case inspirationActions.GET_FEATURED_INSPIRATIONS: {
      return {
        ...state,
        featuredInspirations: {
          ...state.featuredInspirations,
          loading: true,
        },
      };
    }

    case inspirationActions.GET_FEATURED_INSPIRATIONS_SUCCESS: {
      return {
        ...state,
        featuredInspirations: {
          ...action.inspirations,
          loading: false,
        },
      };
    }

    case inspirationActions.RESET_FEATURED_INSPIRATIONS: {
      return {
        ...state,
        featuredInspirations: { ...initialState.featuredInspirations },
      };
    }

    case inspirationActions.GET_ARTICLE_SUCCESS: {
      return {
        ...state,
        article: {
          ...action.payload,
        },
      };
    }

    case inspirationActions.GET_PUBLICATION_SUCCESS: {
      return {
        ...state,
        publication: {
          ...action.payload,
        },
      };
    }

    case inspirationActions.GET_INSPIRATION_FORMATS_SUCCESS: {
      return {
        ...state,
        inspirationFormats: action.payload,
      };
    }

    case inspirationActions.RESET_INSPIRATION_FORMATS: {
      return {
        ...state,
        inspirationFormats: [...initialState.inspirationFormats],
      };
    }

    case inspirationActions.CLEAR_PUBLICATION: {
      return {
        ...state,
        publication: {},
      };
    }

    case inspirationActions.CLEAR_ARTICLE: {
      return {
        ...state,
        article: {} as IArticle,
      };
    }

    default: {
      return state;
    }
  }
}
